<template>
  <div class="question" oncopy="return false;">
    <!-- 问题内容 -->
    <div>sadfasdfasef</div>
    <p class="question_content" v-html="$props.question"></p>
    <!-- 问题选项 -->
    <div class="question_options">
      <div
        :class="['question_options_item', 'clearfix', {'question_options_actitem': item.checked}]"
        v-for="item in $props.optional"
        @click="optionClick(item)"
      >
        <span class="fl question_option_title" :style="{borderRadius:questionType == 2?'0.1rem':'50%'}">{{item.option}}</span>
        <p class="fl question_option_content" v-html="item.content"></p>
      </div>
    </div>

    <!-- <div v-show="question_tip_show" class="question_tip">左滑下一题</div> -->
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        question_tip_show: true
      }
    },
    props: {
      question: String,
      questionType: Number,
      optional: Array,
      sort: Number,
      qLen: Number
    },
    computed: {
      questionTypeStr: function () {
         const _arr = ['', '单选题', '多选题', '判断题']
         return _arr[parseInt(this.$props.questionType)]
      }
    },
    watch:{
      curQIndex: function () {
        this.question_tip_show = false
      }
    },
    methods: {
      optionClick: function (item) {
        const _br = !item.checked
        let _options = this.$props.optional.map(O=>{
          if (O.option == item.option) {
            return {...O,checked: _br}
          } else if (this.$props.questionType != 2) {
            return {...O, checked: false}
          } else {
            return O
          }
        })
        this.$emit('optionsChange', _options)
      }
    }
  }
</script>

<style scoped>
  .question{
    padding: 0 16px;
    margin-top: 13px;
    font-size: 15px;
    touch-action: none;
  }
  .question_head{
    margin-bottom: 10px;
  }
  .question_title{
    font-size: 14px;
    color: #40A452;
  }
  .question_type,.question_all_num{
    font-size: 12px;
    color: #3F3F3F;
  }
  .question_num{
    height: 17px;
    margin-top: 0;
  }
  .question_cur_num{
    font-size: 12px;
    color: #F69100;
  }
  .question_content{
    line-height: 27px;
    margin-bottom: 16px;
  }
  .question_options{
    cursor: pointer;
  }
  .question_options_item{
    margin-bottom: 16px;
  }
.question_option_title{
    width: 32px;
    height: 32px;
    font-size: 15px;
    line-height: 30px;
    margin-right: 12px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    color: #888;
    text-align: center;
    border-radius: 50%;
    font-weight: lighter;
    font-family: Arial;
  }
  .question_options_actitem .question_option_title{
    background-color: #3fbe5b;
    border: 1px solid #3fbe5b;
    color: #fff;
  }
  .question_option_content{
    line-height: 32px;
    width: 290px;
  }
  .question_tip{
      width: 100px;
      height: 35px;
      position: fixed;
      bottom: 150px;
      right: 0;
      background: rgba(0,0,0,.5);
      border-radius: 20px 0 0 20px;
      font-size: 14px;
      color: #fff;
      text-align: center;
      line-height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cdjs/children/Question.vue